<template>
  <div id="edit-project">
    <form novalidate >
        <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{'general._wait_'|translate}}
    
          <v-progress-linear
           indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
      <v-container grid-list-xl fluid>
        <v-layout row wrap>
          <v-snackbar v-model="infoUpdatedSnack">
            <span>{{'medias._media_update_'|translate}}</span>
            <v-btn class="md-primary" @click="infoUpdatedSnack = false">{{'general._ok_'|translate}}</v-btn>
          </v-snackbar>
          <!-- project form -->
          <v-toolbar :md-elevation="1">
            <span class="md-title">{{'media._media_name_'|translate}}: <b>{{form.title}}</b></span>
            <span class="md-title"> {{'media._media_createdDate_'|translate}} : <b>{{ form.created_date }}</b></span>
          </v-toolbar>
          <br>

          <v-flex sm6 style="display:none">
            <v-text-field
              type="text"
              autocomplete="given-name"
              v-model="media_id"
              required
            ></v-text-field>
          </v-flex>
         

          <v-flex xs12 sm6>
            <v-text-field
              :label="$t('medias._media_name_')"
              v-model="form.title"
              autocomplete="given-name"
              required
            ></v-text-field>
          </v-flex>
 
          <v-flex xs12>
            <h5>{{'merchants._merchants_descr_'|translate}}</h5>

            <v-textarea
              placeholder="Détailler"
              ref="projectDescription"
              v-model="form.description"
              :min-height="30"
              :max-height="350"
              required
              outline
            ></v-textarea>
          </v-flex>

          <v-flex xs12 sm6>
               <v-select
              :items="category_type"
              v-model="form.category"
              label="Category Type"
              item-text="type"
              item-value="abbr"
              single-line
            ></v-select>
      
          </v-flex>

           <v-flex xs12 sm6>
            <v-select
              :items="data_type"
              v-model="form.data_type"
              label="Data Type"
              item-text="type"
              item-value="abbr"
              single-line
            ></v-select>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              label="Tags"
              type="text"
             
              v-model="form.tags"
              required
             
            ></v-text-field>
          </v-flex>

              <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center" v-if="form.data_type=='image'">
          
        	<img :src="imageUrl" height="150" v-if="imageUrl"/>
          
					<v-text-field label="Select Image" @click='pickFile_image' v-model='imageName' prepend-icon='attach_file'></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="image"
						accept="image/*"
						@change="onFilePicked_image"
           
					>

				</v-flex>
  
          <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center" v-else-if="form.data_type=='audio'">
          
               <audio 
               v-if="imageUrl"
              controls
              :src="imageUrl">
              Your browser does not support the
              <code>audio</code> element.
              </audio>
                   
       
         
					<v-text-field label="Select audio" @click='pickFile_audio' v-model='imageName' prepend-icon='attach_file'></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="audio"
						accept="audio/*"
						@change="onFilePicked_image"
           
					>

				</v-flex>

          <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center" v-else-if="form.data_type=='video'">
          <div id="output" style="display: inline-block; top: 4px; position: relative ;border: dotted 1px #ccc; padding: 2px;" ></div>
         <!--  <button @click="shoot" style="width: 64px;border: solid 2px #ccc;">Capture</button><br/> -->
         
        	
          <video width="320" height="240" controls v-if="imageUrl" id="video2" >
            <source :src="imageUrl" type="video/mp4">
            Your browser does not support the video tag.
            </video> 
         
					<v-text-field label="Select Video" @click='pickFile_video' v-model='imageName' prepend-icon='attach_file'></v-text-field>
					<input
						type="file"
						style="display: none"
						ref="video"
						accept="video/*"
						@change="onFilePicked_image"
           
					>

				</v-flex>

       <v-flex xs12>
            <v-layout row wrap>
              <v-card-actions style="display:inline">
                <v-btn @click="deleteMedia" color="primary">{{'general._delete_'|translate}}</v-btn>
              </v-card-actions>

              <v-card-actions style="display:inline">
                <router-link :to="{ name: 'widget-medias'}">
                  <v-btn color="primary">{{'general._back_'|translate}}</v-btn>
                </router-link>
              </v-card-actions>

              <v-spacer></v-spacer>
              <v-card-actions style="display:inline">
                <v-btn type="submit" color="primary" @click="updateMedia('yes')">{{'general._save_'|translate}}</v-btn>
              </v-card-actions>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
import { storage } from '@/api/firebaseInit';
import vueSlider from "vue-slider-component";
import { quartiers } from "@/api/quartiers";
import { communes } from "@/api/communes";

const toLower = text => {
  return text.toString().toLowerCase();
};

const searchByName = (items, term) => {
  if (term) {
    return items.filter(item => toLower(item.title).includes(toLower(term)));
  }

  return items;
};

export default {
  name: "edit-media",
  components: {
    vueSlider
  },
    computed: {
    medias(){
      let medias =  this.$store.getters.medias;
      return medias;
    } 
  },
  mounted() {  
 // this.projects =  this.$store.getters.projects;
   //  console.log(" projects "+JSON.stringify(this.projects))     
  },
  created() {
    
    this.media_id = this.$route.params.media_id;
    this.created_by_id = firebase.auth().currentUser.uid;
    this.created_by = firebase.auth().currentUser.displayName;
  
  },
  filters: {
    formatDate: function(value) {
      if (value) {
        return moment(String(value)).format("MM/DD/YYYY");
      }
    }
  },
  data() {
    return {
      thumbnails: '',
      scaleFactor :0,
      snapshots : [],
      valueDeterminate:0,
      loading: false,
      old_images:[],
      images: [],
       created_by_id:"",
       created_by:"",
      imageName: '',
      imageUrl: '',
      imageFile: "",
      Download_image_url:"",
      pagination: {
        sortBy: "title",
        rowsPerPage: "100"
      },
      data_type: ["image", "audio","video"],
      category_type: ["Sermons", "Services", "Messages", "Prayers", "Testimonys"],
      date: null,
      menu: false,
      modal: false,
      infoUpdatedSnack: false,
      jobs: [],
      backers: [],
      zones: quartiers,
      areas: communes,
      media_id: null,
      form: {
          title:'',
          category :'',
          created_date:'',
          created_by_id:firebase.auth().currentUser.uid,
          created_by:firebase.auth().currentUser.displayName,  
          data_type :'',
          description :'',
          tags:'',
          url:''
      }
    };
  },
  beforeRouteEnter(to, from, next) {
    db.collection("medias")
      .doc(to.params.media_id)
      .get()
      .then(function(doc) {
        next(vm => {               
                 (vm.form.title= doc.data().title),
                 (vm.form.category= doc.data().category), 
                 (vm.form.created_date= doc.data().created_date), 
                 (vm.form.created_by_id= doc.data().created_by_id),
                 (vm.form.created_by= doc.data().created_by), 
                 (vm.form.data_type= doc.data().data_type),
                 (vm.form.description= doc.data().description), 
                 (vm.form.tags= doc.data().tags+"");
                 (vm.form.url= doc.data().url);
        });
      });
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
  pickFile_video (type) {
            this.$refs.video.click ()
        },

  pickFile_image (type) {
            this.$refs.image.click ()
        },
  pickFile_audio (type) {
            this.$refs.audio.click ()
        },
  
onFilePicked_image (e) {
        var blob="";
       var that = this
      const files = e.target.files
     
			if(files[0] !== undefined) {
           this.loading = true;
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result
					this.imageFile = files[0] // this is an image file that can be sent to server...
        })
        
          blob = new Blob([files[0]], { type: files[0].type });
          //console.log("blob",blob)
       
     // Upload file and metadata to the object 'images/mountains.jpg'
var uploadTask = storage.ref().child(`media_attachements/${this.created_by_id}/medias/file-${new Date().getTime()}`).put(blob);
var prograss =0;
// Listen for state changes, errors, and completion of the upload.
uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
  function(snapshot) {
  
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
   
  //  console.log('Upload is ' + progress +'val'+ '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
       // console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
      //  console.log('Upload is running');
         this.valueDeterminate=progress
        break;
    }
  }, function(error) {

  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.code) {
    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;

    case 'storage/canceled':
      // User canceled the upload
      break;

    case 'storage/unknown':
      // Unknown error occurred, inspect error.serverResponse
      break;
  }
}, function() {

  // Upload completed successfully, now we can get the download URL
  uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
    console.log('File available at', downloadURL);
     that.saveImageUrl(downloadURL)
          
             downloadURL=''
             blob=''
             
  });
});

  

			} else {
				this.imageName = ''
				this.imageFile = ''
				this.imageUrl = ''
			}
		}
    ,

    /*********************** */
       saveImageUrl (url) {
           this.loading = false;
           this.Download_image_url=url;
            console.log("url",this.Download_image_url)
          if(this.form.data_type==='video'){
          this.shoot();
          }
        },

           saveThumbnailsUrl (url) {
           this.thumbnails=url;
            console.log("saveThumbnailsUrl",this.thumbnails)
         
        },
        
        
    searchOnTable() {
      this.searched = searchByName(this.jobs, this.search);
    },
    getClass: ({ type }) => ({
      // 'md-primary':
    }),
    onSelect(item) {
      this.selected = item;
      this.$router.push({
        name: "edit-media",
        params: {
          media_id: item.media_id
        }
      });
    },
    fetchData() {
      db.collection("medias")
        .doc(this.media_id)
        .get()
        .then(function(doc) {

                 (this.form.title= doc.data().title),
                 (this.form.category= doc.data().category), 
                 (this.form.created_date= doc.data().created_date), 
                 (this.form.created_by_id= doc.data().created_by_id),
                 (this.form.created_by= doc.data().created_by), 
                 (this.form.data_type= doc.data().data_type),
                 (this.form.description= doc.data().description), 
                 (this.form.tags= doc.data().tags+"");
                 (this.form.url= doc.data().url);
        })
          .then(() => {
            console.error("fetch media: ", error);
        })
        .catch(error => {
          console.error("fetch media: ", error);
        });
      

    },

 capture(video, scaleFactor) {
	if(scaleFactor == null){
		scaleFactor = 1;
	}
	var w = video.videoWidth * scaleFactor;
	var h = video.videoHeight * scaleFactor;
	var canvas = document.createElement('canvas');
		canvas.width  = w;
	    canvas.height = h;
	var ctx = canvas.getContext('2d');
		ctx.drawImage(video, 0, 0, w, h);
    return canvas;
} ,
 
 b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
},
/**
 * Invokes the <code>capture</code> function and attaches the canvas element to the DOM.
 */
 shoot() {
   var that = this
   var scaleFactor=0.25;
	var video  = document.getElementById('video2');
	var output = document.getElementById('output');
	var canvas = this.capture(video,scaleFactor);
    
    //console.log("click "+canvas.toDataURL())
    
  var block = canvas.toDataURL().split(";");
// Get the content type of the image
var contentType = block[0].split(":")[1];// In this case "image/gif"
// get the real base64 content of the file
var realData = block[1].split(",")[1];// In this case "R0lGODlhPQBEAPeoAJosM...."

// Convert it to a blob to upload
var blob = this.b64toBlob(realData, contentType);



//console.log("blob",blob)
/*  	this.snapshots.unshift(canvas);
	output.innerHTML = '';
	for(var i=0; i<4; i++){
    output.appendChild(this.snapshots[i]);
   
  }  */

  var uploadTask = storage.ref().child(`media_attachements/${this.created_by_id}/medias/Thumbnails-video-${new Date().getTime()}`).put(blob);
var prograss =0;
// Listen for state changes, errors, and completion of the upload.
uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
  function(snapshot) {
  
    // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
   
    console.log('Upload is ' + progress +'val'+ '% done');
    switch (snapshot.state) {
      case firebase.storage.TaskState.PAUSED: // or 'paused'
        console.log('Upload is paused');
        break;
      case firebase.storage.TaskState.RUNNING: // or 'running'
        console.log('Upload is running');
         this.valueDeterminate=progress
        break;
    }
  }, function(error) {

  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.code) {
    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;

    case 'storage/canceled':
      // User canceled the upload
      break;

    case 'storage/unknown':
      // Unknown error occurred, inspect error.serverResponse
      break;
  }
}, function() {

  // Upload completed successfully, now we can get the download URL
  uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
    console.log('File available thubsnail at', downloadURL);
    that.saveThumbnailsUrl(downloadURL);
     });
});
   
},
    updateMedia(actio) {
      console.log('here');
      var that= this;
      var bloc ={}
        var tags = this.form.tags.split(',');
        if(this.Download_image_url != "" && actio == 'yes') {
          bloc = {
          title:this.form.title,
          category :this.form.category,
          created_date:new Date(),
          created_by_id:this.created_by_id,
          created_by:this.created_by,
          data_type :this.form.data_type,
          description :this.form.description,
          tags:tags,
          url:this.Download_image_url,
          video_thumbnails : this.thumbnails            
        }
        } else {

          bloc = {
          title:this.form.title,
          category :this.form.category,
          created_date:new Date(),
          created_by_id:this.created_by_id,
          created_by:this.created_by,
          data_type :this.form.data_type,
          description :this.form.description,
          tags:tags            
        }

        }
     db.collection("medias")
        .doc(this.media_id)
        .update(bloc)
        .then(() => {
          that.infoUpdatedSnack = true;
             this.$store.dispatch('fetchMedias')
        })
        .catch(error => {
          console.error("Error update/add media: ", error);
        });
      
    },

    backtoRoute () {
       return '/widget-medias';
    },
    deleteMedia() {
      var that = this;
      if (confirm("Are you sure?")) {
        db.collection("medias")
          .doc(this.media_id)
          .delete()
          .then(function() {
            alert(`Cette media a été suprimé`);
           
           
          });
           this.$store.dispatch('fetchMedias')
            this.$router.push({name: 'widget-medias'});
      }
    },
  }
};
</script>
<style lang='scss' scoped>
.md-dialog {
  max-width: 768px;
}
body {
  padding-top: 70px;
}
.md-drawer {
  padding-top: 70px;
}

#my-strictly-unique-vue-upload-multiple-image {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/pages/modifiers/EditMedia.vue